import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class ValidationService {

  constructor() { }

  static emailValidator(control: AbstractControl) {

    const pattern =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    // RFC 2822 compliant regex
    if (control.value != null) {
      if (control.value.
      match(pattern)) {
        return null;
      } else {
        return { 'invalidEmailAddress': true };
      }
    }

  }
  static passwordValidator(control: AbstractControl) {
    // RFC 2822 compliant regex
    if (control.value != null) {

      if (!control.value.match(/(?=^.{8,}$)/)) {

        return { 'invalidLength': true };
      }

      if (!control.value.match(/((?=.*\d)|(?=.*\W+))/)) {

        return { 'notNumbersFound': true };
      }

      if (!control.value.match(/(?=.*[A-Z])/)) {
        return { 'notUpperCaseFound': true };

      }

      if (!control.value.match(/(?=.*[a-z]).*$/)) {

        return { 'notLowerCaseFound': true };
      }

      if (!control.value.match(/(?=.*[!@#\$%\^&\*])/)) {
        return { 'notSpecialCharacteresFound': true };

      }

      return null;
    }
  }

}
